import React from "react";
import { ScrollNavigationMenu, ScrollNavigationMenuItem, Stack } from "sprint-common-web";

import { RecordType } from "../../../../common/types/RecordType";
import { useCloudFileDashboard } from "../common/context/useCloudFileDashboard";
import { useCloudFileDetails } from "../common/useCloudFileDetails";
import { useFileRecordDetails } from "../common/useFileRecordDetails";

export const InfoNavigationItem: ScrollNavigationMenuItem = {
    id: "info",
    label: "Info"
};

export const TechnicalNavigationItem: ScrollNavigationMenuItem = {
    id: "technical",
    label: "Technical"
};

export const PreviewNavigationItem: ScrollNavigationMenuItem = {
    id: "preview",
    label: "Preview"
};

export const FileRecordNavigationItem: ScrollNavigationMenuItem = {
    id: "fileRecord",
    label: "File record"
};

export const NotesNavigationItem: ScrollNavigationMenuItem = {
    id: "notes",
    label: "Notes"
};

export const CloudFileDetailsDashboardNavigation = (): JSX.Element | null => {
    const { lookupFileRecordId } = useCloudFileDashboard();
    const { data: cloudFile } = useCloudFileDetails();

    const { data: lookupFileRecordDetails } = useFileRecordDetails(lookupFileRecordId);

    const items = [
        InfoNavigationItem,
        ...(cloudFile?.recordType === RecordType.Audio || cloudFile?.recordType === RecordType.Video
            ? [TechnicalNavigationItem]
            : []),
        PreviewNavigationItem
    ];

    if (lookupFileRecordDetails) {
        items.push(FileRecordNavigationItem);
        items.push(NotesNavigationItem);
    }

    return (
        <Stack style={{ marginBottom: 20 }}>
            <ScrollNavigationMenu items={items} />
        </Stack>
    );
};
